import { alpha } from "../utils.js";
import { PROJECT_FONT_FAMILY } from "../theme.js";
const globalStyles = (t) => ({
  body: {
    color: t.palette.content.base.default,
    fontFamily: PROJECT_FONT_FAMILY,
    padding: 0,
    margin: 0,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale"
  },
  [t.breakpoints.up("lg")]: {
    "::-webkit-scrollbar": {
      width: 10,
      height: 10,
      backgroundColor: "transparent"
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: alpha(t.palette.secondary.main, 14)
    }
  },
  ".grecaptcha-badge": {
    visibility: "hidden"
  }
});
export {
  globalStyles
};
//# sourceMappingURL=globalStyles.js.map
